import instance from '../api';
import { ErrorNotification } from '../../Utils/data';

interface loginInterface {
  userName: string;
  password: string | number;
}

export const LoginApi = async ({ userName, password }: loginInterface) => {
  try {
    const { data } = await instance('auths/login/ra', {
      method: 'POST',
      data: { email: userName, password },
      headers: { 'Content-Type': 'application/json' },
    });
    localStorage.setItem('token', data.id);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('expires', data.ttl);
    document.location.replace('/');
  } catch (error: any) {
    if (error.response && error.response.status) {
      ErrorNotification({
        status: error.response && error.response.status,
        message: error.response.data.error.message,
      });
    }
  }
};
